import { PiRanking } from "react-icons/pi";
import { RiMedalFill } from "react-icons/ri";
import { cn } from "../../lib/utils";

export function TopClientsByActiveLicenses({ topClients, ...props }) {
   return (
      <div style={{ ...props.style }} className={cn("w-full h-[max(100%,fit)] border! border-(--borderColor)! rounded-(--borderRadius)! **:text-(--textColor) box-border! shadow-(--box-shadow) bg-(--containerBackgroundColor)", props.className)}>
         <div className="flex flex-row gap-2 items-center w-full border-b! border-(--borderColor)! px-5! py-4! box-border! font-bold! text-[0.9rem]!">
            <PiRanking size={19} />
            <span className="font-bold! leading-[0.1]!">Top clientes por licenças ativas</span>
         </div>
         <div className="w-full px-6! py-3! box-border!">
            <table className="table-auto w-full">
               <thead>
                  <tr>
                     <th></th>
                     <th></th>
                     <th></th>
                  </tr>
               </thead>
               <tbody>
                  {topClients.sort((a, b) => b.quantity - a.quantity).map((client, index) => (
                     <tr key={index} className="group/table-row">
                        <td className="box-border! px-0! py-4.5! border-b! border-(--borderColor)! group-last/table-row:border-none!">{index + 1}º</td>
                        <td className="box-border! px-0! py-4.5! border-b! border-(--borderColor)! group-last/table-row:border-none!">
                           <div className="flex flex-row items-center gap-2">
                              <span>
                                 {client.name}
                              </span>
                              {index < 3 && (
                                 <span>
                                    {index === 0 && (<RiMedalFill size={15} className="**:text-yellow-400" />)}
                                    {index === 1 && (<RiMedalFill size={15} className="**:text-gray-400" />)}
                                    {index === 2 && (<RiMedalFill size={15} className="**:text-amber-700" />)}
                                 </span>
                              )}
                           </div>
                        </td>
                        <td className="box-border! px-0! py-4.5! border-b! border-(--borderColor)! group-last/table-row:border-none! text-right!">{client.quantity}</td>
                     </tr>
                  ))}
               </tbody>
            </table>
         </div>
      </div>
   );
}